import { Map, Record } from 'immutable';

import { IReportDataTableAgGridState } from '../types';

export const ReportDataTableAgGridState = Record<IReportDataTableAgGridState>({
  activeColumn: null,
  jobResult: null,
  sumJobResult: null,
  filterValuesByColumn: Map<string, Map<string, number>>()
});
